import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { useEditCameraStore } from "./editCameraStore/editCameraStore";

export const NotesDialogEditCamera = () => {
  const { notesDialogEditCameraOpen, setNotesDialogEditCameraOpen, notesText } =
    useEditCameraStore();

  return (
    <Dialog open={notesDialogEditCameraOpen} fullWidth maxWidth="xs">
      <DialogTitle id="alert-dialog-title">Notes</DialogTitle>
      <DialogContent>
        <DialogContentText>{notesText}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setNotesDialogEditCameraOpen(false);
          }}
          text="Ok"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
